import React from 'react';
import { colors } from '@insurancemenu/imenu-components-lib';
import { SupportedUserRoles } from '@insurancemenu/imenu-components-lib/dist/types';
import { employeeRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { EnrollmentPeriod, EnrollmentType } from 'types/enrollmentService';
import { Reload } from '@insurancemenu/imenu-components-lib/dist/icons';
import SubscriberStatus from 'components/common/election/SubscriberStatus';
import { EmployeeInvitationStatusTypes, SubscriberSERoles } from 'types/electionService';
import StageTag from '../StageTag';
import { createStyles } from './styles';

interface EnrollmentTagProps {
  userRoles: SupportedUserRoles[];
  enrollmentPeriod: EnrollmentPeriod;
  isSubscriberElected?: boolean;
}

interface SubscriberTagProps extends Pick<EnrollmentTagProps, 'isSubscriberElected'> {}
interface StageTagProps extends Pick<EnrollmentTagProps, 'enrollmentPeriod'> {}

const SubscriberTag: React.FC<SubscriberTagProps> = ({ isSubscriberElected }) => {
  return isSubscriberElected ? (
    <SubscriberStatus status={EmployeeInvitationStatusTypes.ELECTED} subSERole={SubscriberSERoles.EMPLOYEE} />
  ) : null;
};

const EnrollmentStageTag: React.FC<StageTagProps> = ({ enrollmentPeriod }) => {
  const classes = createStyles();
  return enrollmentPeriod.type === EnrollmentType.RESUBMIT_NEW_SALE ? (
    <div className={classes.tagWrapper}>
      <StageTag stage={enrollmentPeriod.stage} />
      <Reload width="2.5rem" height="2.5rem" color={colors.blue[300]} className={classes.stageIcon} />
    </div>
  ) : (
    <StageTag stage={enrollmentPeriod.stage} />
  );
};

const EnrollmentTag = ({
  userRoles,
  enrollmentPeriod,
  isSubscriberElected = false,
}: EnrollmentTagProps): JSX.Element => {
  return employeeRights(userRoles) ? (
    <SubscriberTag isSubscriberElected={isSubscriberElected} />
  ) : (
    <EnrollmentStageTag enrollmentPeriod={enrollmentPeriod} />
  );
};
export default EnrollmentTag;
